import type { DisplayedInformation } from '../../shared/chatbot.types';
import { MessageContent } from '../MessageContent';

export const DisplayInformation = ({ info }: { info: DisplayedInformation }) => (
  <section className="sgwt-chatbot-message sgwt-chatbot-information mb-5 py-2 px-3 border-start border-info border-lg bg-info bg-opacity-05">
    <MessageContent message={info.message} />
  </section>
);
